import(/* webpackMode: "eager" */ "/vercel/path0/src/app/flashcards/page.tsx");
